import { Box, Grid, styled, Typography, useTheme } from "@mui/material";

export const CreditRatingInfo = () => {
  const theme = useTheme();

  const creditRatingInfo = [
    {
      color: theme.palette.speedometer.pink.main,
      title: "Finansinė informacija",
      value: "40%",
    },
    {
      color: theme.palette.speedometer.blue.main,
      title: "Kredito istorija",
      value: "30%",
    },
    {
      color: theme.palette.speedometer.violet.main,
      title: "Bendrinė informacija",
      value: "19%",
    },
    {
      color: theme.palette.speedometer.blue.light,
      title: "Verslo sąsajos",
      value: "8%",
    },
    {
      color: theme.palette.speedometer.blue.lighter,
      title: "Domėjimas įmone",
      value: "3%",
    },
    // {
    //   color: theme.palette.speedometer.orange.light,
    //   title: "Pajamos",
    //   value: "5%",
    // },
  ];

  return (
    <Grid container rowSpacing={1}>
      {creditRatingInfo.map((item) => (
        <Grid key={item.title} item xs={12} md={6}>
          <Box spacing={1} mb="0.4rem" mr="1rem">
            <DivFlexAligned color={item.color}>
              <div>
                <div className="circle" />
                <Typography ml="0.5rem" variant="body3" color={item.color}>
                  {item.title}
                </Typography>
              </div>
              <Typography variant="body3" color={item.color}>
                {item.value}
              </Typography>
            </DivFlexAligned>

            <StatusDiv>
              <StatusBar width={item.value} color={item.color} />
            </StatusDiv>
          </Box>
        </Grid>
      ))}
    </Grid>
  );
};

const StatusDiv = styled("div")`
  height: 8px;
  border-radius: 5px;
  background-color: #eeeded;
  display: flex;
`;

const StatusBar = styled("div")`
  background-color: ${({ color }) => color};
  width: ${({ width }) => width};
  height: 8px;
  border-radius: 5px;
`;

const DivFlexAligned = styled("div")`
  display: flex;
  align-items: center;
  justify-content: space-between;
  color: ${({ color }) => color};
  margin-bottom: 0.2rem;

  div {
    display: flex;
    align-items: center;
  }

  span {
    margin-left: 0.5rem;
  }

  .circle {
    border: 2px solid ${({ color }) => color};
    border-radius: 100%;
    height: 6px;
    width: 6px;
    min-width: 6px;
  }
`;
